import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/lib/firebase'

export type SearchBackend = 'classic' | 'v2'

let cached: SearchBackend | null = null
let inflight: Promise<SearchBackend> | null = null

/**
 * Reads appConfig/search.backendV2 (public get).
 * true / missing → v2 (Places + geo buckets)
 * false → classic prefix + gh8 area search (rollback)
 *
 * Override: localStorage.setItem('biddle_search_backend', 'classic'|'v2')
 */
export async function getSearchBackend(): Promise<SearchBackend> {
  const override = localStorage.getItem('biddle_search_backend')
  if (override === 'classic' || override === 'v2') return override

  if (cached) return cached
  if (inflight) return inflight

  inflight = (async () => {
    try {
      const snap = await getDoc(doc(db, 'appConfig', 'search'))
      const backendV2 = snap.exists() ? snap.data()?.backendV2 !== false : true
      cached = backendV2 ? 'v2' : 'classic'
    } catch {
      cached = 'v2'
    } finally {
      inflight = null
    }
    return cached!
  })()

  return inflight
}

export function clearSearchBackendCache() {
  cached = null
}
